import isNil from "lodash/fp/isNil";

class Controller {
  constructor($timeout, $element) {
    "ngInject";

    this.$timeout = $timeout;
    this.$element = $element;
  }

  $onInit() {
    this.contentShow = this.defaultOpened;
    this.content = this.$element.find("md-card-content");

    if (!isNil(this.$groupCtrl)) {
      this.$groupCtrl.addToItems(this);
    }
  }

  $onDestroy() {
    if (!isNil(this.$groupCtrl)) {
      this.$groupCtrl.removeFromItems(this);
    }
  }

  toggleContent() {
    this.contentShow = !this.contentShow;
    this.toggleContentHeight();
    if (!isNil(this.$groupCtrl)) {
      this.$groupCtrl.closeAll(this);
    }
  }

  hideContent() {
    const height = this.content[0].offsetHeight;

    if (height > 0) {
      this.content.css("height", `${height}px`);

      this.$timeout(() => this.content.css("height", "0px"), 0);
    }
  }

  showContent() {
    const originalHeight = this.content[0].offsetHeight;
    this.content[0].removeAttribute("style");
    const height = this.content[0].offsetHeight;

    if (originalHeight === 0) {
      this.content.css("height", "0px");

      this.$timeout(() => this.content.css("height", `${height}px`), 0);
      this.$timeout(() => this.content.removeAttr("style"), 600);
    }
  }

  toggleContentHeight() {
    if (this.contentShow) this.showContent();
    else this.hideContent();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/accordionItem/accordionItem.controller.js